<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.04</b> - Performance & UI improvements, balance changes...
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Balance
        <ul>
          <li>- Reduced the scaling of Fire/Ice/Thunder/Weeping/Venomous weapon procs</li>
          <ul>
            <li class="pl-4">
              * Fire damage: <code>30 + L*6</code> -->
              <code>50 + L*4</code>
            </li>
            <li class="pl-4">* Ice jumps: <code>L/5</code> --> <code>L/7</code></li>
            <li class="pl-4">
              * Lightning damage: <code>30 + L*4</code> -->
              <code>50 + L*2</code>
            </li>
            <li class="pl-4">
              * Weeping/Venomous potency: <code>10 + L</code> -->
              <code>5 + L/2.5</code>
            </li>
          </ul>
          <li>
            - Reduced the MP cost scaling of Summon Dwarf/Elf/Faerie from
            <code>L*100</code> to <code>L*50</code>
          </li>
          <li>
            - Increased Healing Prayer MP cost scaling from
            <code>10 + L*4</code> to <code>5 + L*10</code>
          </li>
          <li>
            - Increased Send Mana AP cost scaling from
            <code>25</code> to <code>45</code>
          </li>
        </ul>
      </li>
      <li>Reduced the Shopkeeper's restock interval from 3hrs to 30mins</li>
      <li>Increased amount of PD sold for real-world currency</li>
      <li>Fixed Armor Spikes</li>
      <li>Fixed the math on XP needed to for Levels 50+ (sorry, Mr. Gentle)</li>
      <li>Fixed a ton of UI layout issues, esp. for smaller resolutions</li>
      <li>
        Fixed a memory leak in the Blessed rendering, a couple other Caverns leaks, an
        Armory leak, and a huge leak for anyone on the web hitting the Refresh button.
      </li>
    </ul>
  </div>
</template>
